import { CustomerType } from '../models/invoice';

export const noSpaceAndLowercaseFr = (
  value: string = CustomerType.CUSTOMER1
): string => value.replace(/(\s|-|\.)+/g, '').toLocaleLowerCase();

export const noSpaceAndLowercaseIt = (
  value: string = CustomerType.CUSTOMER5
): string => value.replace(/(\s|-|\.)+/g, '').toLocaleLowerCase();
